import { createStyles, Drawer, withStyles } from '@material-ui/core';
import React from 'react';
import { APPLICATION_DRAWER_WIDTH } from '../../../../../const/settings';
import AppDrawerSimpleList from './AppDrawerSimpleList';
import { ALMOST_WHITE_COLOR, BLACK_COLOR } from '../../../../../const/color-const';

const styles = createStyles(theme => ({
  root: {
    width: APPLICATION_DRAWER_WIDTH,
    colorScheme: 'dark',
    backgroundColor:
      theme.palette.type === 'light'
        ? ALMOST_WHITE_COLOR
        : BLACK_COLOR,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
}));

const AppDrawerSimple = React.forwardRef((props, ref) => {
  const { classes, menuDefinition, open, onClose } = props;
  return (
    <Drawer
      ref={ref}
      classes={{ paper: classes.root }}
      variant="temporary"
      open={open}
      onClose={onClose}
    >
      <AppDrawerSimpleList
        menuDefinition={menuDefinition}
        onClick={onClose}
      />
    </Drawer>
  );
});

export default withStyles(styles, { name: 'AppDrawerSimple' })(AppDrawerSimple);
